<template>
    <div class="w-full bg-white flex items-center justify-center py-20">
        <div class="flex flex-col space-y-8 border border-neutral-300 py-10 px-14 w-1/2">
            <img src="@/assets/images/canprev_logo.svg" class="manufacturer_canprev_logo" alt="Canprev brand logo">
            <h3 class="text-neutral-800 text-2xl font-semibold">Hello {{ manufacturerName }}!</h3>
            <div>
                <h4 class="text-xl font-semibold text-neutral-800">Please enter PO number</h4>
                <h4 class="text-base font-medium text-neutral-800">Enter the PO number to find the associated lot(s).</h4>
            </div>
            <div class="space-y-1 mb-2 ">
                <label class="flex items-center text-neutral-500 text-sm font-medium" for="password">
                    PO Number
                </label>
                <input v-model="po_number" class="appearance-none border border-neutral-300 rounded-md w-full py-2.5 px-3 text-neutral-800 leading-tight focus:ring-0 focus:outline-none focus:border-primary-500 placeholder:text-neutral-400" 
                    type="text">
                <div v-if="v$.po_number.$error"
                    class="flex items-center tracking-wide text-red-500 text-xs mt-1 ml-1">
                    <span v-for="error of v$.po_number.$errors"
                        :key="error.$uid">
                        {{error.$message}}
                    </span>
                </div>
                <div v-else-if="error" class="py-0.5 text-red-500 text-xs font-normal">{{ error }}</div>
            </div>
            <div class="flex items-center justify-between">
                <button :disabled="isSubmitted" @click="logoutUser" type="button" class="flex items-center justify-center px-5 py-1.5 rounded-md bg-white hover:shadow-md hover:bg-white border text-gray-600"> 
                    Back
                </button>
                <button :disabled="isSubmitted" @click="fetchPoDetails" type="submit" class="flex items-center justify-center px-5 py-1.5 rounded-md bg-primary-500 hover:shadow-md hover:bg-primary-600 text-white"> 
                    <svg v-if="isSubmitted" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Next
                </button>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import axios from 'axios';
import { minLength, maxLength, required, helpers, numeric } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { time } from 'highcharts';
export default {
    setup() {
        return { 
            v$: useVuelidate()
        }
    },
    data() {
        return {
            po_number: '',
            error: '',
            isSubmitted: false
        }
    },
    validations: {
        po_number: {
            required: helpers.withMessage(() => `PO number is required.`, required),
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeUnmount() { // use beforeDestroy() if on Vue 2
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    methods: {
        handleBeforeUnload(e) {
            e.preventDefault();
            e.returnValue = ''; // Shows default confirmation message
        },
       async fetchPoDetails() {
            this.error = ''
            this.isSubmitted = true
            this.v$.$touch();
            if (this.v$.$error) {
                this.isSubmitted = false
                return;
            }
            await axios({
                method: 'get',
                url: `bol-manufacturers/manufacturer-create-options/${this.po_number}`,
            }).then((response) => {
                localStorage.removeItem('lotItems');
                localStorage.removeItem('checkedLotMap');
                localStorage.removeItem(`verification_answers`);
                localStorage.removeItem(`shipmentSkids`);
                localStorage.removeItem(`uploadedFiles`);
                localStorage.removeItem(`uploadedDocuments`);
                localStorage.removeItem(`current_tab`);
                localStorage.removeItem(`completed_tabs`);
                localStorage.removeItem('shipmentSkidsCount');
                this.isSubmitted = false;
                const responseData = response.data
                localStorage.setItem('lotItems', JSON.stringify(responseData))    
                const completedLotItems = JSON.parse(localStorage.getItem('completedLotItems'))
                // Flatten completedLotItems to extract all lotcodes
                if(responseData.length == 1 && completedLotItems?.length) {
                    console.log(completedLotItems)
                    const targetLotcode = responseData[0].lotcode;
                    const isFirstLotcodePresent = completedLotItems.some(item =>
                        item.completed_lot_items.some(subItem => subItem.lotcode == targetLotcode)
                    );
                    if(isFirstLotcodePresent) {
                        this.error = `You have already completed a form for lot ${responseData[0]?.lotcode} of ${'PO'+responseData[0]?.po_number}. Please enter a different PO number.`
                        return this.error
                    }
                }          
                this.$router.replace({
                    name: 'manufacturer_purchase_order_detail'
                })
            }).catch(err => {
                if ('response' in err && 'detail' in err.response.data && err.response.data.detail) {
                    this.error = err.response.data.detail
                } else {
                    this.error = 'Something went wrong, please try again'
                }
                this.isSubmitted = false;
            })
        },
        logoutUser() {
            const savedItemsAvailable = localStorage.getItem('savedItemsAvailable')
            if(savedItemsAvailable){
                this.$router.replace({name: 'manufacturer_purchase_order_lot_confirmation'}) 
            } else {
                localStorage.removeItem('completedLotItems')
                localStorage.removeItem('savedItemsAvailable')
                localStorage.removeItem('lotItems')
                localStorage.removeItem(`bol_id`)
                this.$router.replace({name: 'logout'})
            }
        }
    },
    computed: {
        manufacturerName() {
            return this.$store.getters.authUser.name
        }
    }
}
</script>